module.exports = __webpack_public_path__ + "media/plusque5tentative.058dbc62.mp3";